import script from "./DomainRecordEdit.vue?vue&type=script&setup=true&lang=js"
export * from "./DomainRecordEdit.vue?vue&type=script&setup=true&lang=js"

import "./DomainRecordEdit.vue?vue&type=style&index=0&id=6030b36e&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6030b36e"]])

export default __exports__